import { DialogComponent } from '@theme/dialog';

class QuoteDialog extends DialogComponent {}

if (!customElements.get('quote-dialog')) {
  customElements.define('quote-dialog', QuoteDialog);
}

function initQuoteButtons() {
  document.querySelectorAll('.get_quote_btn').forEach((btn) => {
    // avoid duplicate handlers
    if (btn.dataset.quoteInit) return;
    btn.dataset.quoteInit = 'true';

    btn.addEventListener('click', (event) => {
      event.preventDefault();
      const next = btn.nextElementSibling;
      let dialogComponent = null;

      if (next && next.tagName && next.tagName.toLowerCase() === 'quote-dialog') {
        dialogComponent = next;
      } else {
        const container =
          btn.closest('.shopify-section, [data-block-id], [data-section-id]') || btn.parentElement;
        dialogComponent = (container && container.querySelector('quote-dialog')) || document.querySelector('quote-dialog');
      }

      if (!dialogComponent) return;
      dialogComponent.showDialog();
    });
  });
}

document.addEventListener('DOMContentLoaded', initQuoteButtons);
// re-run when new sections are loaded (e.g. via AJAX or theme editor)
document.addEventListener('shopify:section:load', initQuoteButtons);
